const CLOSE_DELAY_MS = 400;

function initializeFlyoutMenu() {
  const shortcuts = document.querySelectorAll('.main-nav-item');
  let currentOpenPopup = null;
  let closeTimeoutId = null;

  shortcuts.forEach(setupShortcut);

  function setupShortcut(shortcut) {
    const popup = shortcut.querySelector('sl-popup');
    let isMouseOver = false;

    attachEventListeners(shortcut, popup);

    function handleMouseEnter() {
      isMouseOver = true;
      clearTimeout(closeTimeoutId);
      openPopup(popup);
    }

    function handleMouseLeave(e) {
      // in case of leaving one but then hovering over the other element
      if (popup.matches(':hover') || shortcut.matches(':hover')) {
        return;
      }

      isMouseOver = false;
      schedulePopupClose(popup);
    }

    function handleFocusIn() {
      clearTimeout(closeTimeoutId);
      openPopup(popup);
    }

    function handleFocusOut() {
      setTimeout(() => {
        if (!shortcut.contains(document.activeElement)) {
          closePopup(popup);
        }
      }, 0);
    }

    function schedulePopupClose(popup) {
      clearTimeout(closeTimeoutId);
      closeTimeoutId = setTimeout(() => {
        if (!isMouseOver) {
          closePopup(popup);
        }
      }, CLOSE_DELAY_MS);
    }

    function attachEventListeners(shortcut, popup) {
      shortcut.addEventListener('mouseenter', handleMouseEnter);
      shortcut.addEventListener('mouseleave', handleMouseLeave);
      popup.addEventListener('mouseenter', handleMouseEnter);
      popup.addEventListener('mouseleave', handleMouseLeave);
      shortcut.addEventListener('focusin', handleFocusIn);
      shortcut.addEventListener('focusout', handleFocusOut);
    }
  }

  function openPopup(popup) {
    if (currentOpenPopup && currentOpenPopup !== popup) {
      closePopup(currentOpenPopup, false);
    }
    clearTimeout(closeTimeoutId);
    popup.classList.remove('exit');
    popup.active = true;
    setTimeout(() => {
      popup.classList.add('enter');
    }, 10);
    currentOpenPopup = popup;
  }

  function closePopup(popup, animate = true) {
    if (currentOpenPopup !== popup) {
      return;
    }

    if (animate) {
      popup.classList.remove('enter');
      popup.classList.add('exit');
      setTimeout(() => {
        if (currentOpenPopup === popup) {
          popup.active = false;
          popup.classList.remove('exit');
          currentOpenPopup = null;
        }
      }, 300);
    } else {
      popup.classList.remove('enter', 'exit');
      popup.active = false;
      currentOpenPopup = null;
    }
  }
}

const supportsHover = window.matchMedia('(hover: hover)').matches;

if (supportsHover) {
  import('@shoelace-style/shoelace/dist/components/popup/popup.js').then(() => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeFlyoutMenu);
    } else {
      initializeFlyoutMenu();
    }
  });
}
